module.exports = __webpack_public_path__ + "img/result-info.f42b7bf1.svg";